module.exports = __webpack_public_path__ + "static/img/referrer3.4b84eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/referrer3.png
// module id = qBKf
// module chunks = 1